import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  currentCampaignId: null,
  currentCampaignName: null,
  currentSection: "campaign-setup",
  createdCampaignSection: "",
  shortlistedCreatorLoading: false,
  creatorsList: [],
  total: 0,
  size: 0,
  totalPages: 0,
  page: 0,
  loaderForButton: false,
  shortlistPlatformData: {},
  shortListTabActive: 'instagram',
  isCreatorMixActive: false,
  getCampainDetailsDataOverall: {},
  shortlistCreatorIndivialActivation: [],
  isSelectedShortlist: false,
  selectedShortlistedCreators: [],
  deSelectedShortlistedCreators: [],
  sort: {
    sortBy: "followers",
    sortOrder: -1,
  },
  shortListSelectAllDisable: null,
  isShowNormalizedView: false,
  currentCampaignSelection: 'unarchive'
};
const campaignSlice = createSlice({
  name: "campaign",
  initialState,
  reducers: {
    setCurrentCampaignId(state, action) {
      state.currentCampaignId = action?.payload;
    },
    setCurrentCampaignName(state, action) {
      state.currentCampaignName = action?.payload;
    },
    setCurrentCampaignSelection(state, action) {
      state.currentCampaignSelection = action?.payload;
    },
    setCurrentSection(state, action) {
      state.currentSection = action?.payload;
    },
    setCreatedCampaignSection(state, action) {
      state.createdCampaignSection = action?.payload;
    },
    setShortlistedCampaignCreatorLoading(state, action) {
      state.shortlistedCreatorLoading = action?.payload;
    },
    setCampaignShortlistedList(state, action) {
      state.creatorsList = action?.payload?.pagination
        ? [...state.creatorsList, ...action?.payload?.creatorsList]
        : action?.payload?.creatorsList;
      state.total = action?.payload?.total;
      state.totalPages = action?.payload?.totalPages;
      state.page = action?.payload?.page;
      state.size = action?.payload?.size;
      state.loaderForButton = action?.payload?.loaderForButton;
      state.shortlistPlatformData = action?.payload?.shortlistPlatformData
      state.shortListSelectAllDisable = action?.payload?.shortListSelectAllDisable
    },
    setLoaderForButton(state, action) {
      state.loaderForButton = action?.payload;
    },
    setShortlistPlatformType(state, action) {
      state.shortListTabActive = action?.payload
    },
    setSelectedShortlistCreator(state, action) {
      state.selectedShortlistedCreators = [...state.selectedShortlistedCreators, action.payload]
    },
    setDeselectedShortlistCreator(state, action) {
      state.selectedShortlistedCreators = state.selectedShortlistedCreators.filter(
        (item) => !(item?._id === action.payload?._id && item?.platform === action?.payload?.platform))
    },
    selectAllShortlistedCreators(state, action) {
      state.selectedShortlistedCreators = action.payload;
    },
    setCreatorMixActive(state, action) {
      state.isCreatorMixActive = action?.payload
    },
    setGetCampainDetailsDataOverall(state, action) {
      state.getCampainDetailsDataOverall = action?.payload
    },
    setCampaignStates(state, action) {
      const { payload: { key, value } } = action
      state[key] = value;
      return state
    },
    clearCampaign(state, action) {
      return initialState;
    },
    setShortlistCreatorIndivialActivation(state, action) {
      state.shortlistCreatorIndivialActivation = action?.payload
    },
    clearParticularStates(state, action) {
      state.shortListTabActive = 'instagram';
      state.deSelectedShortlistedCreators = [];
      state.selectedShortlistedCreators = [];
      state.isSelectedShortlist = false;
    }
  },
});

export const campaignActions = campaignSlice.actions;

export default campaignSlice;
